import React from 'react';
import { CodeIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CreatePushApiButton } from '../CreatePushApiButton/CreatePushApiButton';
import styles from './emptyPushApiReport.module.scss';

export const EmptyPushApiReport = () => {
    return (
        <div className={styles['container-empty']}>
            <CodeIcon className={styles['code-icon']} />
            <div className={styles['header']}>
                <FormattedMessage
                    className={styles['header']}
                    id="app.campaigns.reports.push-api.report.empty"
                    defaultMessage="There are no API Integrations"
                />
            </div>
            <div className={styles['create-button']}>
                <CreatePushApiButton />
            </div>
        </div>
    );
};
